import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true,  // クッキーを含める設定
});

export const register = (user) => instance.post('/register', user);
export const login = (user) => instance.post('/login', user);
export const logout = () => instance.post('/logout');
export const getCurrentUser = () => instance.get('/current_user');
export const checkSession = () => instance.get('/check_session');
export const resetPasswordRequest = (email) => instance.post('/reset-password-request', { email });
export const resetPassword = (token, new_password) => instance.post(`/reset-password/${token}`, { new_password });
export const getAudio = (filename) => instance.get(`/get_audio/${filename}`);

// プロジェクト保存・取得・更新機能の追加
export const saveProject = async (projectData) => {
    const formData = new FormData();
    formData.append('name', projectData.name);
    formData.append('audio_data', new Blob([projectData.audio_data], { type: 'audio/wav' }), 'audio_data.wav');
    formData.append('position_ref', JSON.stringify(projectData.position_ref));
    formData.append('index_ref', JSON.stringify(projectData.index_ref));

    const response = await instance.post('/save_project', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response;
};
export const getProject = (id) => instance.get(`/get_project/${id}`);
export const getProjects = () => instance.get('/projects');
export const updateProject = async (id, projectData) => {
    const formData = new FormData();
    if (projectData.name !== undefined) formData.append('name', projectData.name);
    if (projectData.audio_data !== undefined) formData.append('audio_data', new Blob([projectData.audio_data], { type: 'audio/wav' }), 'audio_data.wav');
    if (projectData.position_ref !== undefined) formData.append('position_ref', JSON.stringify(projectData.position_ref));
    if (projectData.index_ref !== undefined) formData.append('index_ref', JSON.stringify(projectData.index_ref));

    const response = await instance.put(`/update_project/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response;
};
export const deleteProject = (projectId) => {
    return instance.delete(`/projects/${projectId}`)
};

export default instance;
